import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ChevronDown from 'sushiweb/Icons/all/ChevronDown';
import OnClickOutside from 'sushiweb/HOC/OnClickOutside';
import grey from 'sushiweb/tokens/color/grey';
import coal from 'sushiweb/tokens/color/black';
import white from 'sushiweb/tokens/color/white';
import { Logout } from 'sushiweb/Icons';
import { P } from 'sushiweb/Typography/Text';
import Envelope from 'sushiweb/Icons/all/Envelope';

import _noop from 'lodash-es/noop';
import { logoutUser, signOut } from '../../../../actions/auth';
import { openErrorToast } from '../../../../reducers/uiLogic';
import { applicableFlowTypes, currentFlowTypeEnum } from '../constants';
import { formatAmountInRupees, truncateUptoNDigits } from '../../../../helpers';
import {
  RupeesSignIconWithCircle,
  UserProfileIcon,
} from '../../../../components/SVGs/commonSVGs';

const UserWidget = ({
  userDetails,
  logUserOut,
  showDropdown,
  showErrorToast,
  selectedWorkspace,
  currentFlow,
}) => {
  const [isDropdownVisible, setDropDownVisible] = useState(false);
  const toggleDropDown = () => setDropDownVisible(!isDropdownVisible);
  const closeDropdown = () => setDropDownVisible(false);
  const onLogoutClick = () => {
    if (window.zoauth !== undefined) {
      signOut()
        .then(res => {
          console.log(res);
          logUserOut();
        })
        .catch(err => {
          console.log(err);
          showErrorToast();
        });
    }
  };

  return (
    <UserWidget.Wrapper clickable={showDropdown}>
      <OnClickOutside
        removeHandler={!showDropdown}
        handleClickOutside={closeDropdown}
      >
        <UserWidget.Head onClick={showDropdown ? toggleDropDown : _noop}>
          <UserWidget.ProfileIcon>{UserProfileIcon()}</UserWidget.ProfileIcon>
          <UserWidget.Name>{userDetails.name}</UserWidget.Name>
          {showDropdown ? (
            <StyledChevronDown
              size={18}
              visible={isDropdownVisible}
              color={coal}
            />
          ) : null}
        </UserWidget.Head>
        {showDropdown ? (
          <UserWidget.Dropdown visible={isDropdownVisible}>
            {currentFlow === currentFlowTypeEnum.FLOW_TYPE_LIMIT ? (
              <UserWidgetLink style={{ cursor: 'default' }}>
                <UserWidgetLink.IconContainer>
                  {RupeesSignIconWithCircle()}
                </UserWidgetLink.IconContainer>
                <UserWidgetLink.Text>
                  Limit:&nbsp;
                  <span id='amount'>
                    {' '}
                    {formatAmountInRupees(selectedWorkspace?.credit_limit)}
                  </span>
                </UserWidgetLink.Text>
              </UserWidgetLink>
            ) : null}
            <UserWidgetLink style={{ cursor: 'default' }}>
              <UserWidgetLink.IconContainer>
                <Envelope />
              </UserWidgetLink.IconContainer>
              <UserWidgetLink.Text>
                {truncateUptoNDigits(userDetails.email, 20)}
              </UserWidgetLink.Text>
            </UserWidgetLink>
            <UserWidgetLink onClick={onLogoutClick}>
              <Logout />
              <P>Logout</P>
            </UserWidgetLink>
          </UserWidget.Dropdown>
        ) : null}
      </OnClickOutside>
    </UserWidget.Wrapper>
  );
};

export const Anchor = styled.div`
  color: ${coal};
  display: flex;
  justify-content: space-between;
`;

const StyledChevronDown = styled(ChevronDown)`
  transform: rotate(${props => (props.visible ? '180deg' : 0)});
  transition: transform 0.2s ease;
`;

UserWidget.propTypes = {
  userDetails: PropTypes.objectOf(PropTypes.any),
  logUserOut: PropTypes.func,
  showErrorToast: PropTypes.func,
  showDropdown: PropTypes.bool,
  selectedWorkspace: PropTypes.objectOf(PropTypes.any),
  currentFlow: PropTypes.oneOf(applicableFlowTypes),
};

UserWidget.defaultProps = {
  userDetails: {},
  logUserOut: _noop,
  showErrorToast: _noop,
  showDropdown: true,
  selectedWorkspace: {},
  currentFlow: currentFlowTypeEnum.FLOW_TYPE_PPI,
};

export const UserWidgetLink = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 1rem;
  background: var(--coolgreycoolgrey-50, #f8f9fc);
  color: var(--coolgreycoolgrey-900, #293142);
  font-size: 1.5rem;
  text-decoration: none;
  border-left: 0.6rem solid transparent;
  p {
    margin-left: 1.6rem;
    color: ${grey.z800};
  }
  #amount {
    font-family: Lexend-400;
  }
  &:hover {
    background: ${grey.z100};
  }
`;

UserWidgetLink.IconContainer = styled.div`
  width: 25px;
`;

UserWidgetLink.Text = styled.div`
  overflow: hidden;
  padding: 0px 10px;
`;

UserWidget.Wrapper = styled.div`
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'default')};
  position: relative;
  padding: 8px;
`;

UserWidget.Dropdown = styled.div`
  position: absolute;
  top: 3.2rem;
  right: 0;
  visibility: ${props => (props.visible ? 'visible' : 'hidden')};
  opacity: ${props => (props.visible ? 1 : 0)};
  width: 25rem;
  background: ${white};
  border-radius: 8px;
  box-shadow: 0px 2px 8px rgba(28, 28, 28, 0.15);
  transform: translateY(${props => (props.visible ? '20px' : 0)});
  transition: transform 0.25s ease, opacity 0.25s ease;
  overflow: hidden;
`;

UserWidget.Head = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  max-width: 20rem;
`;

UserWidget.ProfileIcon = styled.div`
  padding: 8px;
  border-radius: 12px;
  border: 0.5px solid var(--COOL-GREY-COOL-GREY300, #d0d4dc);
`;

UserWidget.Name = styled.span`
  font-size: 1.5rem;
  font-weight: 500;
  margin: 0 1rem;
  color: ${coal};
  max-width: 15rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const mapDispatchToProps = dispatch => ({
  logUserOut: () => dispatch(logoutUser()),
  showErrorToast: () => dispatch(openErrorToast()),
});

export default connect(
  null,
  mapDispatchToProps,
)(UserWidget);
